import React, { useEffect,useState } from 'react'
import _ from 'lodash';

import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectChannelListItems, selectChannelsQueryItems } from '../../../../../redux/channels/selector';
import { channels } from '../../../../../redux/channels/action';
import ChannelComponent from '../components/channel.component';

let currentChange: any = {}
const Channel= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectChannelsQueryItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const channelItems = useSelector(selectChannelListItems)
  
  
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedChannel,
    setSelectedChannel
  ] = useState<any>([])
  const [
    channelImageIndex,
    setChannelImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
 
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


  const fetchChannelById= ()=>{
    dispatch(channels.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/channels/query`,entity:'channels',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedChannel({ ...selectedChannel, [field]: event });
  }

  useEffect(
    () => {
     
      if (parmas?.id > 0) {
        fetchChannelById()
        setIsLoading(false)
    }else {
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedChannel(queryItems?.result?.items)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
        mediaFiles.length - 1,
        1
      )
    if (parmas?.id > 0) {
      await dispatch(channels.resetAction({ actionType: 'update' }))
      await dispatch(channels.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/channels`,entity:'channels',jsonData:{
          
    Records: [
      {
        
       
         ...selectedChannel
        
    
     
    }
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(channels.resetAction({ actionType: 'create' }))
      await dispatch(channels.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/channels`,entity:'channels',jsonData:{
          
      Records: [
        {
        
         
            ...selectedChannel
          
      
       
      }
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/platform-management/channels')
} 
const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 172,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
  
    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setChannelImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'channel',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
  
    mediaFiles[channelImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
  
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )

  
    return (
    <>
     {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         />}
    {isLoading ? <PageLoader /> : 
          <ChannelComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedChannel={selectedChannel}
           back={back}
           handleFormSubmit={handleFormSubmit}
           changeImage={changeImage}
           mediaFiles={mediaFiles}
           handleFormItemChange={handleFormItemChange}
           channels={channelItems?.result?.items}
          />  
        }
    
          </>
    )
    
    }
   
    export default Channel;
